import { useState } from "react";
import { useCookies } from "react-cookie";
import { useToken } from "@app/hooks/useToken";
import { useMsal } from "@azure/msal-react";
import { StorageKey } from "@app/constants";
import { useForceLogout } from "./useForceLogout";
import { msalConfig } from "@app/api";
import { setItem } from "@app/helpers/storage.helper";

let logoutRedirectPending = false;
export const isLogoutRedirectPending = () => logoutRedirectPending;

export const useAuth = () => {
  const { saveTokens, getTokens, clearTokens } = useToken();
  const { clearTimer, setTimer } = useForceLogout();
  const [isLogged, setIsLogged] = useState(getTokens().accessToken);
  const { instance } = useMsal();
  const [cookies] = useCookies([
    StorageKey.AUTH_ACCESS_TOKEN,
    StorageKey.LAST_UPDATED_AT,
  ]);

  const login = (data: any) => {
    const { idToken, account } = data;
    saveTokens({
      token: idToken,
      accountId: account.homeAccountId,
    });
    setIsLogged(idToken);

    setItem(StorageKey.IS_SHOWN_DATA_USAGE_POPUP, true);

    setTimer();
  };

  // const clearAllStorage = () => {
  //   try {
  //     // Clear sessionStorage
  //     sessionStorage.clear();

  //     // Clear all localStorage items (including MSAL cache)
  //     const allKeys = Object.keys(localStorage);
  //     allKeys.forEach((key) => {
  //       localStorage.removeItem(key);
  //     });
  //   } catch (error) {
  //     console.error("Error clearing storage:", error);
  //   }

  //   // Clear all cookies using document.cookie - comprehensive approach
  //   try {
  //     const cookiesList = document.cookie.split(";");
  //     cookiesList.forEach((cookie) => {
  //       const eqPos = cookie.indexOf("=");
  //       const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
  //       if (name) {
  //         // Clear cookie with multiple domain/path combinations
  //         const hostname = window.location.hostname;
  //         const paths = ["/", window.location.pathname];
  //         const domains = [
  //           hostname,
  //           `.${hostname}`,
  //           ...(hostname.includes(".") ? [
  //             hostname.split(".").slice(-2).join("."),
  //             `.${hostname.split(".").slice(-2).join(".")}`
  //           ] : []),
  //           "localhost"
  //         ];

  //         // Clear cookie for all path/domain combinations
  //         paths.forEach((path) => {
  //           domains.forEach((domain) => {
  //             document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
  //             document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
  //           });
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     console.error("Error clearing cookies:", error);
  //   }

  //   // Also clear using react-cookie for tracked cookies
  //   try {
  //     clearTokens();
  //   } catch (error) {
  //     console.error("Error clearing tokens:", error);
  //   }
  // };

  // const logout = async (logOutHead?: boolean) => {
  //   // IMPORTANT: Get account info BEFORE clearing anything
  //   // MSAL needs the account to perform logout redirect
  //   clearAllStorage();
  //   let account = null;
  //   let accountId: string | undefined = undefined;

  //   try {
  //     // Get accountId from cookies BEFORE clearing anything
  //     accountId = cookies.tokens?.accountId;
  //     // debugger;
  //     // console.log("accountId", accountId);
  //     // Get account from MSAL instance (uses localStorage internally)
  //     account = accountId
  //       ? instance.getAccountByHomeId(accountId)
  //       : instance.getAllAccounts()[0] || null;
  //   } catch (error) {
  //     console.error("Error getting account for logout:", error);
  //     // Try to get account without accountId as fallback
  //     try {
  //       account = instance.getAllAccounts()[0] || null;
  //     } catch (fallbackError) {
  //       console.error("Error getting account fallback:", fallbackError);
  //     }
  //   }

  //   // Build the logout redirect URI - always redirect to /login after logout
  //   // B2C requires an absolute URL for postLogoutRedirectUri
  //   let logoutRedirectUri: string;

  //   if (logOutHead && msalConfig.auth.redirectUri) {
  //     // If redirectUri is a full URL, extract origin and add /login
  //     try {
  //       const redirectUrl = new URL(msalConfig.auth.redirectUri);
  //       logoutRedirectUri = `${redirectUrl.origin}/login`;
  //     } catch {
  //       // If it's not a valid URL, use current origin + /login
  //       logoutRedirectUri = `${window.location.origin}/login`;
  //     }
  //   } else {
  //     // Always use absolute URL for B2C logout redirect
  //     logoutRedirectUri = `${window.location.origin}/login`;
  //   }

  //   // Clear app state (but keep MSAL cache in localStorage until redirect happens)
  //   //clearTokens();
  //   setIsLogged("");
  //   clearTimer();

  //   // Function to clear all storage and cookies

  //   // Perform logout redirect - clear everything ONLY when redirect actually happens
  //   try {
  //     await instance.logoutRedirect({
  //       account: account || undefined,
  //       postLogoutRedirectUri: logoutRedirectUri,
  //       onRedirectNavigate: () => {
  //         // Clear EVERYTHING (cookies + localStorage) right before redirect happens
  //         // This ensures complete cleanup before browser navigates to B2C logout
  //         clearAllStorage();
  //         return true; // Allow the redirect to proceed
  //       },
  //     });

  //     // Backup: Also clear after a short delay in case onRedirectNavigate doesn't fire
  //     // This is a safety measure - the redirect should happen before this executes
  //     setTimeout(() => {
  //       clearAllStorage();
  //     }, 100);

  //   } catch (error: any) {
  //     console.error("Logout error:", error);

  //     // If logout redirect fails, clear everything and manually navigate to login page
  //     clearAllStorage();
  //     window.location.href = "/login";
  //   }
  // };

  const logout = async (logOutHead?: boolean) => {
    await instance.logoutRedirect({
      account: instance.getAccountByHomeId(cookies.tokens.accountId),
      onRedirectNavigate() {
        clearTokens();
        setIsLogged("");
        clearTimer();
      },
      postLogoutRedirectUri: logOutHead
        ? msalConfig.auth.redirectUri
        : window.location.pathname,
    });
  };

  return { login, logout, isLogged };
};
